import $ from 'jquery';
import '@fancyapps/fancybox';

jQuery(function ($) {

    var s = skrollr.init({
        smoothScrolling: true
    });

    $('[data-fancybox="gallery"]').fancybox({
        backFocus : false,
        buttons: [
            "zoom",
            "slideShow",
            "fullScreen",
            "close"
        ]
    });

    $('.fb-video').fancybox({
        scrolling: false,
        fitToView: true,
        autoSize: false,
        afterLoad: function () {
            this.width = $(this.element).data("width");
            this.height = $(this.element).data("height");
        }
    });

    // disable skrollr if using handheld device
    if( /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Mobile|Opera Mini/i.test(navigator.userAgent) ) {
        skrollr.init().destroy();
    }

    jQuery(function ($) {
        $('.jsToggleNav').on('click', function() {
            $('body').toggleClass('menu-open');
        });
    });

    $('.forward > a').on('click', function(e) {
        e.preventDefault();
        let menuItem = $(this).parent('li');
        let parentUL = $(menuItem).parent('UL');
        $(menuItem).find('ul').addClass('active');
        $(parentUL).addClass('child-active');
        $('.jsMenuBack').html('Back');
        $('.jsMenuBack').addClass('back');
    });

    $('.jsMenuBack').on('click', function(e) {

        $('.jsMenuBack').html('Menu');
        $('.jsMenuBack').removeClass('back');

        e.preventDefault();

        $('.jsMainNav ul.active').each(function(i, obj) {
            $(this).removeClass('active');
        });

        $('.jsMainNav ul.child-active').each(function(i, obj) {
            $(this).removeClass('child-active');
        });
    });

    $('.jsToggleAccordion').on('click', function() {

        let accordionItem = $(this).closest('.jsAccordionItem');

        let accordion = $(this).data('accordion');
        let accordionStatus = 'inActive';
        if ($(accordionItem).hasClass('active')) {
            accordionStatus = 'active';
        }

        $('.jsAccordionItem').removeClass('active');
        $('.jsAccordion button').attr('aria-expanded', 'false');
        if (accordionStatus == 'inActive') {
            $(accordionItem).addClass('active');
            $('button', this).attr('aria-expanded', 'true');
            $('.jsAccordionContent-' + accordion).slideDown();
            //$('html, body').scrollTop($(accordionItem).offset().top);
        } else {
            $(accordionItem).removeClass('active');
            $('button', this).attr('aria-expanded', 'false');
            $('.jsAccordionContent-' + accordion).slideUp();
        }
    });

    $('.jsPostCarousel').each(function(){
        $(this).slick({
            slidesToShow: 1,
            infinite: false,
            variableWidth: true,
            prevArrow: $(this).parent().find('.prev'),
            nextArrow: $(this).parent().find('.next'),
            responsive: [
                {
                    breakpoint: 480,
                    settings: {
                        variableWidth: false,
                        centerMode: false,
                    }
                }
            ]
        });
    });

    $('.jsGalleryCarousel').each(function(){
        $(this).slick({
            slidesToShow: 1,
            infinite: true,
            prevArrow: $(this).parent().find('.prev'),
            nextArrow: $(this).parent().find('.next'),
        });
    });

    function animateInView() {

        let scrollOffset = 100;

        $('.animate-in-view').each(function() {
            if ($(window).scrollTop()+$(window).height() >= $(this).position().top + scrollOffset && $(window).scrollTop() < $(this).position().top + $(this).height()) {
                if (!$(this).hasClass('can-animate')){
                    $(this).addClass('can-animate');
                }
            }
        });
    }

    animateInView();

    $(window).bind("scroll", function(event) {
        animateInView();
    });

});

let jsToggleFilter = document.getElementsByClassName('jsToggleFilter')[0];
let filter = document.getElementById('filter');

if (jsToggleFilter) {
    jsToggleFilter.onclick = function () {
        if (filter.classList.contains('show-mobile')) {
            filter.classList.remove('show-mobile');
            jsToggleFilter.classList.remove('active');
        } else {
            filter.classList.add('show-mobile');
            jsToggleFilter.classList.add('active');
        }
    }
}

let resizeTimer;
window.addEventListener("resize", () => {
    document.body.classList.add("resize-animation-stopper");
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(() => {
        document.body.classList.remove("resize-animation-stopper");
    }, 400);
});